import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Grid, Box, Typography, Button, Tooltip, CircularProgress, Checkbox, FormControlLabel } from '@mui/material';
import {setShowBottomMenu} from 'store/slice/EcomSlice';
import { setPartnershipInitiationMode } from 'store/slice/EcomSlice';

export default function MlmBenefits() {
    const dispatch = useDispatch();
    const {mlmUserObj} = useSelector((state) => state.ecomslice.mlm);
    useEffect(()=>{
        dispatch(setShowBottomMenu(false));
        if (mlmUserObj && mlmUserObj.partnershipstatus && mlmUserObj.partnershipstatus==='CONFIRMED'){
            dispatch(setPartnershipInitiationMode(false));
            dispatch(setShowBottomMenu(true));
        }
            
        else
            dispatch(setPartnershipInitiationMode(true));
    },[])
    return (
        <>
            <Grid container xs={12} direction="row" justifyContent="flex-end" sx={{ width: '100%',}} >
                
            </Grid>
            <Grid>
            {/* <Box lg={12} sx={{ flexGrow: 1 }}>
                <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '60vh' }}> */}
                    <Grid container direction="column" justifyContent="flex-start" sx={{ width: '100%' }} >
                        
                            <Grid item xs={12} sx={{ backgroundColor: 'white' }}>
                                <Grid container>
                                    <Grid item xs={12} sx={{ padding: 1, }}>
                                        <Typography variant="h6">As Business Associate, you can get 20% discount on your each purchase and also from the purchase made by your referrals.</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sx={{ backgroundColor: 'white' }}>
                                <Grid container>
                                    <Grid item xs={12} sx={{ pl: 1, }}>
                                        <Typography variant="h6">Referral Points can be earned at different levels on Order Value, as shown below -</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sx={{ backgroundColor: 'white', padding: 1 }}>
                                <Grid container justifyContent="center" sx={{ padding: .25 }} >
                                    <Grid item xs={8}>
                                        <Typography variant="h6">Customer Discount</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant="h5">&nbsp;&nbsp;&nbsp;20%</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container justifyContent="center" sx={{ padding: .25 }}>
                                    <Grid item xs={8}>
                                        <Typography variant="h6">Level 1 Credit</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant="h5">&nbsp;&nbsp;&nbsp;10%</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container justifyContent="center" sx={{ padding: .25 }}>
                                    <Grid item xs={8}>
                                        <Typography variant="h6">Level 2 Credit</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant="h5">&nbsp;&nbsp;&nbsp;7.5%</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container justifyContent="center" sx={{ padding: .25 }} >
                                    <Grid item xs={8}>
                                        <Typography variant="h6">Level 3 Credit</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant="h5">&nbsp;&nbsp;&nbsp;5%</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container justifyContent="center" sx={{ padding: .25 }} >
                                    <Grid item xs={8}>
                                        <Typography variant="h6">Level 4 Credit</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant="h5">&nbsp;&nbsp;&nbsp;2.5%</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container justifyContent="center" sx={{ padding: .25 }} >
                                    <Grid item xs={8}>
                                        <Typography variant="h6">Level 5 Credit</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant="h5">&nbsp;&nbsp;&nbsp;2.0%</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container justifyContent="center" sx={{ padding: .25 }} >
                                    <Grid item xs={8}>
                                        <Typography variant="h6">Level 6 Credit</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant="h5">&nbsp;&nbsp;&nbsp;2.0%</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={12} sx={{ padding: .5, }}>
                                        <Typography variant="h6">Your income is directly proportional to the effort you invest and the size of your referral network. It offers unlimited potential to scale earnings.</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    {/* </Grid>
            
            </Box> */}
        </Grid>
        </>
    )
}